import {BaseCollaboratorModal} from 'sma.applicant/components/collaborators/base_collaborator_modal';

class CollaboratorModal extends BaseCollaboratorModal {
	constructor(config) {
		super(
			{
				applicationId: config.applicationId,
				isOwner: config.isOwner,
				isTask: true,
				defaultPermission: config.defaultPermission,
				defaultPermissionIsEditor: config.defaultPermissionIsEditor,
				defaultPermissionIsViewer: config.defaultPermissionIsViewer,
			}
		);
	}

	postSendInvite() {
		new sma.tasks.CollaboratorGrid({applicationId: this.applicationId, isOwner: this.isAppOwner});
		this.loader.hide();
		this.modal.hide();
	}
}

module.exports = {
	CollaboratorModal: CollaboratorModal,
}